import { render, staticRenderFns } from "./PepItem.vue?vue&type=template&id=bfd736fa&scoped=true&"
import script from "./PepItem.vue?vue&type=script&lang=js&"
export * from "./PepItem.vue?vue&type=script&lang=js&"
import style0 from "./PepItem.vue?vue&type=style&index=0&id=bfd736fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd736fa",
  null
  
)

export default component.exports